import * as React from 'react'
import { useLocation, Redirect } from 'react-router-dom'
import { matchPath } from 'react-router-dom'

import * as Paths from 'paths'
import { REACT_APP_FRONTEND_URL } from 'env'
import { currentPath } from 'utils/urlUtils'
import { useAuth } from 'hooks/UseAuth'
import { useHeaders } from 'hooks/useHeaders'

import { isEmpty } from 'lodash'
import { getOrigin } from 'utils/location'

interface Props {
  children?: React.ReactNode
}

const AppAuthWrapper = ({ children }: Props) => {
  const pathsArray = Object.values(Paths)
  const customDomain = getOrigin() !== REACT_APP_FRONTEND_URL
  const auth = useAuth()
  const headers = useHeaders()
  const location = useLocation()

  const match = matchPath(location.pathname, {
    path: pathsArray,
    exact: true,
  })
  const integrationRedirectUris = [
    Paths.INSTAGRAM_OAUTH_REDIRECT_PATH,
    Paths.FACEBOOK_OAUTH_REDIRECT_PATH,
    '/oauth/instagram/callback',
    '/oauth/facebook/callback',
    '/oauth/meta_ads/callback',
    '/oauth/google_ads/callback',
  ]
  const dontRedirect = (customDomain && !match) || (match && integrationRedirectUris.includes(location.pathname))

  // Only redirect to signup if we've checked auth and it's still null/empty
  // Skip redirect for design pages as they handle their own access control
  const isDesignPage = location.pathname.startsWith('/designs/')
  const hasCheckedAuth = auth !== null || headers !== undefined
  const shouldRedirect = (!auth || isEmpty(headers)) && !dontRedirect && hasCheckedAuth && !isDesignPage
  if (shouldRedirect) {
    const url = currentPath(location)
    return (
      <Redirect to={{ pathname: Paths.LOGIN_OR_SIGNUP_PATH, search: `?redirect_to=${url}`, state: { next: url } }} />
    )
  }

  return <>{children}</>
}

export default AppAuthWrapper
